import { settings } from "app";
import { ArrayField, Datagrid, TextField } from "react-admin";

const UniversitiesSection = () => {
  return (
    <ArrayField source="universities">
      <Datagrid
        bulkActionButtons={false}
        rowClick={false}
        size="small"
        sx={settings.style.detailsDatagrid}
      >
        <TextField
          label="Университет"
          source="name"
          sortable={false}
        />
        <TextField
          label="Град"
          source="city"
          sortable={false}
        />
        <TextField
          label="Еразъм код"
          source="erasmusCode"
          sortable={false}
        />
        <TextField
          label="Работен език"
          source="workingLanguage"
          sortable={false}
        />
        <TextField
          label="Контакт"
          source="contact"
          emptyText="—"
          sortable={false}
        />
        <TextField
          label="Имейл"
          source="email"
          emptyText="—"
          sortable={false}
        />
        <TextField
          label="Сайт"
          source="websiteLink"
          emptyText="—"
          sortable={false}
        />
        <TextField
          label="Максимален престой"
          source="maximumStay"
          sortable={false}
        />
        <TextField
          label="Бройка места за обучение на студенти"
          source="studentStudyPlaces"
          sortable={false}
        />
        <TextField
          label="Бройка места за практика на студенти"
          source="studentInternshipPlaces"
          sortable={false}
        />
        <TextField
          label="Бройка места за обучение на преподаватели"
          source="staffTeachingPlaces"
          sortable={false}
        />
        <TextField
          label="Бройка места за практика на преподаватели"
          source="staffTrainingPlaces"
          sortable={false}
        />
        <TextField
          label="Коментар"
          source="comment"
          emptyText="—"
          sortable={false}
        />
      </Datagrid>
    </ArrayField>
  );
};

export default UniversitiesSection;
